import { render, staticRenderFns } from "./EventHistory.vue?vue&type=template&id=21ec534f&scoped=true&"
import script from "./EventHistory.vue?vue&type=script&lang=js&"
export * from "./EventHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ec534f",
  null
  
)

export default component.exports